import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, l = /* @__PURE__ */ e("path", {
  fill: "#D80027",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), s = /* @__PURE__ */ e("path", {
  fill: "#F0F0F0",
  d: "m27.405 13.407-1.413 5.045-4.242-.783-2.73-5.628-7.375 2.617-.582-1.639-1.93-.238 1.454 4.098 5.076-1.298 1.442 4.065-3.508 5.178 5.954 5.078-1.129 1.324.76 1.79 2.821-3.308-3.662-3.747 2.799-3.281 6.239.45 1.42-7.697 1.711.316 1.171-1.552-4.276-.79Z"
}, null, -1), c = [
  l,
  s
];
function r(i, d) {
  return t(), o("svg", n, [...c]);
}
const a = { render: r };
export {
  a as default,
  r as render
};
